import { fetchStaticJson } from './fetchStaticJson';

function deepMerge(target, source) {
  const output = { ...target };
  Object.keys(source || {}).forEach((key) => {
    const t = output[key];
    const s = source[key];
    if (
      t && s &&
      typeof t === "object" &&
      typeof s === "object" &&
      !Array.isArray(t)
    ) {
      output[key] = deepMerge(t, s);
    } else {
      output[key] = s;
    }
  });
  return output;
}

export function resolveBotEntryForDomain(domainName, botName) {
  const { projectsConfig = {} } = window.config || {};
  let project = projectsConfig[domainName];
  let projectKey = domainName;

  if (!project || !project.bots) {
    const defaultProject = projectsConfig.defaultProject;
    if (!defaultProject) return null;
    projectKey = defaultProject;
    project = projectsConfig[defaultProject];
    if (!project || !project.bots) return null;
  }

  let resolvedBotName = botName;
  let bot = project.bots[botName];
  if (!bot) {
    resolvedBotName = project.defaultBot;
    bot = resolvedBotName ? project.bots[resolvedBotName] : null;
  }

  if (bot == null) return null;
  return { projectKey, project, resolvedBotName, bot };
}

// Returns the redirect path for root "/" - uses default project and its default bot from global config.
export function getDefaultRedirectPath() {
  const { projectsConfig = {} } = window.config || {};
  const defaultProject = projectsConfig.defaultProject;
  if (!defaultProject) return null;
  const project = projectsConfig[defaultProject];
  if (!project?.defaultBot) return null;
  return `/${defaultProject}/${project.defaultBot}`;
}

// Returns the redirect path for "/:domainName" - uses the given domain's default bot.
export function getDefaultRedirectPathForDomain(domainName) {
  const { projectsConfig = {} } = window.config || {};
  const project = projectsConfig[domainName];
  if (!project?.defaultBot) return null;
  return `/${domainName}/${project.defaultBot}`;
}

export function listBotsFromProjectsConfig() {
  const { projectsConfig = {} } = window.config || {};
  const out = [];
  Object.keys(projectsConfig).forEach((key) => {
    if (key === "defaultProject") return;
    const project = projectsConfig[key];
    if (!project?.bots) return;
    Object.keys(project.bots).forEach((botName) => {
      out.push({ projectKey: key, botName });
    });
  });
  return out;
}

export function getBotConfig(domainName, botName) {
  const wc = window.config || {};
  const { projectsConfig, ...sharedRoot } = wc;

  const resolved = resolveBotEntryForDomain(domainName, botName);
  if (!resolved) return null;

  const { project, bot } = resolved;
  if (typeof bot === "string") {
    return null;
  }

  const projectSettings = { ...project };
  delete projectSettings.defaultBot;

  let config = deepMerge({}, sharedRoot);
  config = deepMerge(config, projectSettings);
  config = deepMerge(config, bot);

  return config;
}

export async function loadBotConfig(url) {
  return fetchStaticJson(url);
}

export async function ensureBotConfigForRoute(domainName, botName) {
  const entry = resolveBotEntryForDomain(domainName, botName);
  if (!entry) {
    throw new Error('Unknown bot');
  }
  if (typeof entry.bot === 'string') {
    entry.project.bots[entry.resolvedBotName] = await loadBotConfig(entry.bot);
  }
  return getBotConfig(domainName, botName);
}